import React from "react"
import SectionDivider from "../shared/section-divider"
import { useStaticQuery, graphql } from "gatsby"
import { ContentContainer, SectionTitle, UpperOverlayStyle } from "./sdk-benefits.style"
import FeatureGrid from "../../design-system/organisms/feature-grid"
import Grid from "../shared/grid"

export default function AdditionalFeatures() {
  const query = useStaticQuery(graphql`
    query {
      dev_support_icon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Benefits Icons/dev_support_icon.svg"
        }
      ) {
        publicURL
      }
      docs_icon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Benefits Icons/docs_icon.svg"
        }
      ) {
        publicURL
      }
      getting_started_icon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Benefits Icons/getting_started_icon.svg"
        }
      ) {
        publicURL
      }
      sample_apps_icon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Benefits Icons/sample_apps_icon.svg"
        }
      ) {
        publicURL
      }
    }
  `)

  const featureContent = [
    {
      title: "Sample Applications",
      text:
        "Leverage our sample applications across a variety of use cases and experiences to get up and running quickly.",
      icon: query.sample_apps_icon.publicURL,
    },
    {
      title: "Robust Documentation",
      text:
        "With well documented resources for all features and components offered across iOS, Android and Web SDKs, building your own mapping experience is simple.",
      icon: query.docs_icon.publicURL,
    },
    {
      title: "Getting Started Guides",
      text:
        "Follow our step-by-step guide for setting up a new venue to get the core elements running before incorporating the features unique to your experience.",
      icon: query.getting_started_icon.publicURL,
    },
    {
      title: "Developer Support",
      text:
        "Mappedin's Integrations team is dedicated to the evolution of our SDKs and their successful implementations.",
      icon: query.dev_support_icon.publicURL,
    },
  ]

  return (
    <>
      <SectionDivider />
      <Grid overlayStyle={UpperOverlayStyle}>
        <SectionTitle>Mappedin SDK Benefits</SectionTitle>
        <ContentContainer>
          <FeatureGrid items={featureContent} />
        </ContentContainer>
      </Grid>
      <SectionDivider flip />
    </>
  )
}
